@if (fControlName(); as fControlName) {
  <input
    [attr.id]="fControlName"
    [type]="type()"
    [formControlName]="fControlName"
    [class]="classNames"
    [attr.data-formControlName]="fControlName"
    [attr.placeholder]="placeholder()"
    [attr.autocomplete]="autocomplete()"
    [attr.data-testid]="testId()" />
}
